import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const addAccessControl = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/access-control'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const getAccessControl = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/access-control'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateAccessControl = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/access-control/${params.id}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const deleteAccessControl = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/access-control/${params.id}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getUserFromAccessControl = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/access-control/users'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}
const accessControlApi = {
	addAccessControl: addAccessControl,
	getAccessControl: getAccessControl,
	updateAccessControl: updateAccessControl,
	deleteAccessControl: deleteAccessControl,
	getUserFromAccessControl: getUserFromAccessControl,
}

export default accessControlApi
